/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFilePageBlock } from './DatabaseFilePageBlock';
import {
    DatabaseFilePageBlockFromJSON,
    DatabaseFilePageBlockFromJSONTyped,
    DatabaseFilePageBlockToJSON,
} from './DatabaseFilePageBlock';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseAudioPageBlock
 */
export interface DatabaseAudioPageBlock extends DatabaseFilePageBlock {
}

/**
 * Check if a given object implements the DatabaseAudioPageBlock interface.
 */
export function instanceOfDatabaseAudioPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseAudioPageBlockFromJSON(json: any): DatabaseAudioPageBlock {
    return DatabaseAudioPageBlockFromJSONTyped(json, false);
}

export function DatabaseAudioPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseAudioPageBlock {
    return json;
}

export function DatabaseAudioPageBlockToJSON(value?: DatabaseAudioPageBlock | null): any {
    return value;
}

